<template>

    <m-edit1/>

    <m-div v-bind='{...{},...{}}' :style='""' class="container my-2" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="row " >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="col-lg-6 mx-auto text-center" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="col-12 " >
                <template #default>   <m-h2 v-bind='{...{},...{}}' :style='"border-radius: 15px;"' class="bg-secondary p-4 mt-5  shadow " >
                <template #default>لطفا وارد حساب کاربری خود شوید   </template>
                </m-h2><m-a v-bind='{...{"href":"{\"name\":\"Login\",\"params\":{}}","target":"_self"},...{}}' :style='""' class="" >
                <template #default>   <m-button v-bind='{...{},...{}}' :style='""' class="col-3mx-auto btn btn-secondary mt-4 shadow" >
                <template #default>ورود/ثبت نام   </template>
                </m-button></template>
                </m-a></template>
                </m-div></template>
                </m-div></template>
                </m-div></template>
                </m-div>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mDiv from '@moeinmdn/miw-alpha-components/src/package/Tags/Div'; import mH2 from '@moeinmdn/miw-alpha-components/src/package/Tags/H2'; import mA from '@moeinmdn/miw-alpha-components/src/package/Tags/A'; import mButton from '@moeinmdn/miw-alpha-components/src/package/Tags/Button';

export default {
    name: 'HomeView',
    components: {mEdit1, mDiv,mH2,mA,mButton },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
